import { useEffect, useState } from "react";
import { NumberInput } from "../../../components/numberInput/numberInput";
import { useParams } from "react-router";
import { AdminHeader } from "../../../components/adminHeader/adminHeader";
import { Button } from "../../../components/button/button";
import { Input } from "../../../components/input/input";
import { useOpenPage } from "../../../hooks/useOpenPage";
import { Spring } from "../../../components/spring/spring";
import AdminAPI from "../../../api/AdminAPI";
import SuperAdminAPI from "../../../api/SuperAdminAPI";

import { Text } from "../../../components/text/text";

import styles from "./addCafe.module.css"

const CafeSetting = ({ val, setVal, label, error, type, ...params }) => {
    return (
        <div className={styles.cafe_setting}>
            <Text as="div" variant="caption" className={styles.cafe_setting_label} >{label}</Text>
            {type === "text" && <Input error={error} value={val} setValue={setVal} type="text" {...params} />}
            {type === "number" && <NumberInput error={error} val={val} setVal={setVal} {...params} />}
        </div>
    )
}

const initialSettings = (val = null) => ({
    name: val || "",
    address: val || "",
    group: val || "",
    maxEmpCount: val || 0,
});

export const CreateCafePage = () => {
    const { cafeId } = useParams();

    const [settings, setSettings] = useState(initialSettings());
    const [settingErrors, setSettingErrors] = useState(initialSettings(false));

    useEffect(() => {
        if (!cafeId) return;

        AdminAPI
            .fetchCafeInfo(cafeId)
            .then(setSettings)
            .catch(console.error);
    }, [cafeId]);

    const validateData = () => {
        let error = false;

        if (settings.name.length <= 1) {
            setSettingErrors(prev => ({ ...prev, name: true }));
            error = true;
        }

        if (settings.address.length <= 1) {
            setSettingErrors(prev => ({ ...prev, address: true }));
            error = true;
        }

        if (settings.maxEmpCount < 1) {
            setSettingErrors(prev => ({ ...prev, maxEmpCount: true }));
            error = true;
        }

        return error;
    }

    useEffect(() => {
        setSettingErrors(initialSettings(false));
    }, [settings]);

    const openPage = useOpenPage();
    const [loading, setLoading] = useState(false);
    const onSaveData = () => {
        setSettingErrors(initialSettings(false));
        if (validateData()) return;
        setLoading(true);
        SuperAdminAPI
            .createCafe({ ...settings, group: settings.group === "" ? null : settings.group })
            .then(openPage(`/superadmin/cafe`))
            .catch(console.error)
            .finally(() => setLoading(false));
    }

    return (
        <>
            <AdminHeader title="Настройки предприятия" />
            <Text as="div" variant="body" className="page_description" >
                На этой странице Вы можете создать новое предприятие.
            </Text>

            <CafeSetting
                label="Название"
                type="text"
                val={settings.name}
                setVal={(val) => setSettings(prev => ({ ...prev, name: val }))}
                error={settingErrors.name}
            />
            <CafeSetting
                label="Адрес"
                type="text"
                val={settings.address}
                setVal={(val) => setSettings(prev => ({ ...prev, address: val }))}
                error={settingErrors.address}
            />
            <CafeSetting
                label="Количество сотрудников на смене"
                type="number"
                val={settings.maxEmpCount}
                setVal={(val) => setSettings(prev => ({ ...prev, maxEmpCount: val }))}
                error={settingErrors.maxEmpCount}
            />
            <CafeSetting
                label="Группа (опционально)"
                type="text"
                placeholder="Название группы"
                val={settings.group}
                setVal={(val) => setSettings(prev => ({ ...prev, group: val }))}
                error={settingErrors.group}
            />

            <Spring />

            <Button
                onClick={onSaveData}
                text="Добавить предприятие"
                disabled={loading}
            />
        </>
    )
}
